import { forwardRef, useImperativeHandle, useRef } from 'react';

import BushfireSky, {
  type BushfireSkyRef,
} from '0_canvas/Perils/BushfirePeril/BushfireSky/BushfireSky';

import BushfireClouds from './BushfireClouds/BushfireClouds';

export interface BushfirePerilProps {
  animationProgress?: number;
}

export interface BushfirePerilRef {
  animationProgress: number;
}

const BushfirePeril = forwardRef<BushfirePerilRef, BushfirePerilProps>(
  ({ animationProgress = 1 }, ref) => {
    const animationProgressRef = useRef<number>(animationProgress);

    const bushfireSkyRef = useRef<BushfireSkyRef>(null!);

    useImperativeHandle(ref, () => ({
      get animationProgress() {
        return animationProgressRef.current;
      },
      set animationProgress(n: number) {
        animationProgressRef.current = n;
        bushfireSkyRef.current.opacity = n;
      },
    }));

    return (
      <>
        <BushfireSky
          radius={1900}
          opacity={animationProgress}
          ref={bushfireSkyRef}
        />
        <BushfireClouds
          cloudsRadius={1640}
          holeRadius={1440}
          lightningAreaRadius={80}
          altitude={0}
          baseCloudVolume={80}
          density={0.014}
        />
      </>
    );
  }
);

BushfirePeril.displayName = 'BushfirePeril';
export default BushfirePeril;
